import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _callSuper2(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import { Component } from 'react';
import FormId from '../../components/Form/FormId';
import PlayerInterface from '../../api/PlayerInterface';

var ChangeEmail = require('../../assets/star/forms/changeEmail.form');

var UpdateEmail = /*#__PURE__*/function (_Component) {
  function UpdateEmail(props) {
    var _this2;

    _classCallCheck(this, UpdateEmail);

    _this2 = _callSuper2(this, UpdateEmail, [props]);

    _this2.initForm = function () {
      var _this2$props = _this2.props,
          setFormInfo = _this2$props.setFormInfo,
          email = _this2$props.email;
      setFormInfo({
        key: FormId.CURRENT_EMAIL,
        value: email,
        validated: true
      });
    };

    _this2._updatePlayerProfile = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(handleResponse) {
        var formInfo, body, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                formInfo = _this2.props.formInfo;

                if (formInfo.email.validated) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                body = {
                  email: formInfo.email.value
                };
                _context.prev = 4;
                _context.next = 7;
                return PlayerInterface.updatePlayerProfile(body);

              case 7:
                response = _context.sent;

                if (response) {
                  !!handleResponse && handleResponse(true);

                  _this2.setState({
                    responseSuccess: true,
                    messageResponse: 'Your email has been successfully updated!'
                  });
                } else {
                  !!handleResponse && handleResponse(false);

                  _this2.setState({
                    responseSuccess: false,
                    messageResponse: 'Something went wrong. Try again or contact customer support.'
                  });
                }

                _context.next = 16;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](4);
                !!handleResponse && handleResponse(false);
                console.log('Zendesk Error: ', _context.t0);

                _this2.setState({
                  responseSuccess: false,
                  messageResponse: 'Something went wrong. Try again or contact customer support.'
                });

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 11]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this2.state = {
      layout: ChangeEmail,
      messageResponse: '',
      responseSuccess: null
    };
    return _this2;
  }

  _inherits(UpdateEmail, _Component);

  return _createClass(UpdateEmail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initForm();
    }
  }, {
    key: "render",
    value: function render() {
      var render = this.props.render;
      var _this$state = this.state,
          layout = _this$state.layout,
          messageResponse = _this$state.messageResponse,
          responseSuccess = _this$state.responseSuccess;
      return render({
        layout: layout,
        updateEmail: this._updatePlayerProfile,
        messageResponse: messageResponse,
        responseSuccess: responseSuccess
      });
    }
  }]);
}(Component);

export { UpdateEmail as default };